import * as React from "react";


type Props = {
  text?: string;
  ctaHref?: string;
  ctaLabel?: string;
};


export function PromoRibbon({
  text = "Full-service garage in Milton · Oil changes, brakes, tires & more · Book online",
  ctaHref = "/book",
  ctaLabel = "Book Now",
}: Props) {
  return (
    <section
      role="note"
      className="relative overflow-hidden border-b border-[#00AADD]/20"
      style={{ background: "linear-gradient(135deg, #04101E 0%, #071828 50%, #04101E 100%)" }}
    >
      {/* Subtle electric shimmer line */}
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-px"
        style={{ background: "linear-gradient(90deg, transparent, rgba(0,170,221,0.5), transparent)" }}
      />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-10 items-center justify-between gap-4">
          <p className="text-xs font-medium tracking-wide text-white/60">
            <span className="text-[#00AADD] font-semibold">APA Automotive</span>
            {" · "}
            {text}
          </p>
          {ctaHref && ctaLabel ? (
            <a
              href={ctaHref}
              className="hidden sm:inline-flex shrink-0 rounded-lg border border-[#00AADD]/35 bg-[#00AADD]/10 px-3 py-1 text-xs font-semibold text-[#00AADD] transition hover:bg-[#00AADD]/20 hover:border-[#00AADD]/60 focus:outline-none focus:ring-2 focus:ring-[#00AADD]/50"
            >
              {ctaLabel}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
